<template>
<nav class="navbar dev-only" v-if="devMode && !hide">
  <div class="navbar-brand">
    <div class="navbar-item">
      <a class="button is-black" @click="$store.commit('updateDevMode', false)">X</a>
      <strong> DEV MODE!</strong>
    </div>
    <a class="navbar-item" @click="hide=true">Hide</a>
    <div class="navbar-burger burger" :class="{'is-active': menuIsActive}"
         data-target="devMenu"
         @click="toggleMenu">
      <span></span> <span></span> <span></span>
    </div>
  </div>
  <div id="devMenu" class="navbar-menu" :class="{'is-active': menuIsActive}">
      <div class="navbar-start">
        <b-checkbox class="navbar-item" v-model="devWorkers">Dev Workers</b-checkbox>
        <b-checkbox class="navbar-item" v-model="testPay">Test
          Payments</b-checkbox>
        <b-field class="navbar-item">
          <b-input v-model="impersonateUid" placeholder="impersonate uid/email"/>
          <p class="control" v-if="impersonateUid" @click="impersonateUid=''">
            <a class="button is-primary">X</a>
          </p>
        </b-field>
      </div>
  </div>
</nav>
</template>

<script>
import Store from "../store.js"
import { debounce } from '@/util.js'
import Firebase from '../firebase.js'
var db = Firebase.database

window._pixxiEnableDevMode = function() {
  Store.commit('updateDevMode', true)
}
window._pixxiDisableDevMode = function() {
  Store.commit('updateDevMode', false)
}
  
export default {
  name: 'DevBar',
  data() { return {
    hide: false,
    menuIsActive: false,
  }},
  computed: {
    devMode: function() {
      return this.$store.state.dev.developmentClient
    },
    devWorkers: {
      get: function() { return this.$store.state.dev.developmentWorkers },
      set: function(v) { this.$store.commit('updateDevWorkers', v) }
    },
    testPay: {
      get: function() { return this.$store.state.dev.testPayments },
      set: function(v) { this.$store.commit('updateTestPayments', v) }
    },
    impersonateUid: {
      get: function() { return this.$store.state.dev.impersonateUid },
      set: debounce(250, function(v) {
        console.log('set impersonateUid', '"'+v+'"')
        v = v.trim()
        if (/.+@.+\..+/.test(v)) { 
          this.impersonateByEmail(v)
        } else if (v.length >= 24 || v.length==0) {
          this.$store.commit('updateImpersonateUid', v)
        }
      })
    },
  },
  methods: {
    toggleMenu: function() {
      this.menuIsActive = !this.menuIsActive
    },
    impersonateByEmail: function(email) {
      console.log('impersonateByEmail', email)
      db.ref('/users').orderByChild('personal/email')
        .equalTo(email).limitToFirst(1)
        .once('value', snap => {
          const users = snap.val()
          if (users) {
            const uids = Object.keys(users)
            console.log('snap uids', uids)
            if (uids) {
              this.$store.commit('updateImpersonateUid', uids[0])
            }
          }
        })
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DevBar.vue